import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

/**
 * Hook to send GTM view_cart event with cart summary details.
 * It checks if lineItems are available and then sends the event.
 */

const useViewCart = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleViewCartEvent = useCallback(
    (cartTotalsInfo) => {
      if (!isGTMEnabled || !cartTotalsInfo) return;
      const { cartTotal, lineItems, couponName } = cartTotalsInfo;
      if (Array.isArray(lineItems) && lineItems.length > 0) {
        sendGTMEvent({
          event: "view_cart",
          currency: CURRENCY_CODE,
          value: cartTotal?.total ?? 0,
          items: formatItems(lineItems, couponName),
        });
      }
    },
    [isGTMEnabled]
  );

  return { handleViewCartEvent };
};

export default useViewCart;
